import { useEffect, useState } from 'react';
import { listAdmins, getUser } from './api';

export function useIsAdmin() {
  const [state, setState] = useState<{ loading: boolean; isAdmin: boolean; email: string | null }>({
    loading: true, isAdmin: false, email: null
  });

  useEffect(() => {
    (async () => {
      try {
        const user = await getUser();
        const email = user?.userDetails?.toLowerCase() ?? null;
        if (!email) { setState({ loading: false, isAdmin: false, email: null }); return; }
        const data = await listAdmins();
        const isAdmin = data.admins.some(a => a.email === email);
        setState({ loading: false, isAdmin, email });
      } catch {
        setState({ loading: false, isAdmin: false, email: null });
      }
    })();
  }, []);

  return state;
}
